import { _getPPTList } from "@/api";
import { debounce } from "lodash";

//   // {
//   id: 123,
//   name: '2023工作总结',
//   url: '/public/images//custom/fall/preview.png',
//   moreActive: false,
//   isEdit: false
// }
const PPTList = reactive<any[]>([]);
const paramsConfig = reactive({
  isLoading: false,
  isOver: false,
  page: 1,
  pageSize: 100,
});
const totalPage: Ref<number> = ref(0);

const initPage = () => {
  PPTList.splice(0, PPTList.length);
  paramsConfig.isLoading = false;
  paramsConfig.isOver = false;
  paramsConfig.page = 1;
  paramsConfig.pageSize = 20;
};

const usePPTList = () => {
  const getPPTList = debounce(async () => {
    try {
      if (paramsConfig.isLoading || paramsConfig.isOver) return;
      paramsConfig.isLoading = true;
      const res: any = await _getPPTList({
        page: paramsConfig.page,
        page_size: paramsConfig.pageSize,
      });
      const data =
        res.data.map((i: any) => {
          return {
            ...i,
            moreActive: false,
            isEdit: false,
          };
        }) || [];
      totalPage.value = res.total;

      PPTList.push(...data);
      paramsConfig.isOver =
        paramsConfig.page * paramsConfig.pageSize > totalPage.value;
      paramsConfig.page++;
    } catch (e: any) {
      console.error(e);
    } finally {
      paramsConfig.isLoading = false;
    }
  }, 200);

  return { getPPTList, paramsConfig };
};

export { PPTList, usePPTList, initPage };
